import { formFieldsConfigProcessed } from "./config/BusinessDetailsConfig";
import { formFieldsState } from "./state/BusinessDetailsState";
import { formFieldsValidation } from "./validations/BusinessDetailsValidations";
import { BUSINESS_DETAILS_CONSTANTS } from "../../constants";

export const formName = BUSINESS_DETAILS_CONSTANTS.FORM_NAME;
export const formHeader = BUSINESS_DETAILS_CONSTANTS.FORM_HEADER;
export const formDescription = BUSINESS_DETAILS_CONSTANTS.FORM_DESCRIPTION;
export const formConfig = formFieldsConfigProcessed;
export const formValidation = formFieldsValidation;
export const formState = formFieldsState;
